<template>
  <v-select
    :value="value"
    @input="$emit('input', $event)"
    filled
    :hide-details="true"
    :items="items"
    :label="title"
  ></v-select>
</template>

<script>
export default {
  name: "DataOutputPicker",

  props: ["value", "title", "workflow"],

  computed: {
    items() {
      if (this.workflow) return ["none", "variable", "result"];
      return ["none", "variable", "field", "page_field"];
    },
  },
};
</script>